import React from 'react';
import { useInstance } from '../../support/ioc/useInstance';
import { ArticleLink } from '../../app/intercom/ArticleLink.tsx';
import { IArticleKey } from '../../app/intercom/IntercomService.ts';
import { TrackingService } from '../../support/tracking/TrackingService.ts';

export const AdvisoryLink: React.FC<{ text?: string, url?: string; articleKey?: IArticleKey, bold?: boolean }> = ({ text, url, articleKey, bold }) => {

    const tracker = useInstance(TrackingService);

    const onClick = () => {
        tracker.track('Advisory Link Opened', () => ({ text: text || url, url, articleKey }));
    };

    if (url && !articleKey) {
        return (
            <a href={url} onClick={onClick} target="_blank">
                {text || url}
            </a>
        );
    } else if (!url && articleKey && text) {
        return (
            <ArticleLink articleKey={articleKey} onClick={onClick}>
                {text}
            </ArticleLink>
        );
    } else {
        throw new Error('Either url or articleKey must be provided, but not both, and text is required if no url.');
    }
};
